export const groupBy = (objectArray, groupKey) =>
  objectArray.reduce((data, obj) => {
    (data[obj[groupKey]] = data[obj[groupKey]] || []).push(obj);

    return data;
  }, {});
